import React from 'react';
import { Typography } from '@material-ui/core';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { COLOR, SIZE, useStyles } from '~/components/Checkbox/styles';
import IconButton from '~/components/IconButton';

export default function Checkbox({ size, color, label, labelVariant, checked, onChange, disabled }) {
  const classes = useStyles({ color, size });
  return (
    <div className={classes.checkboxContainer}>
      <IconButton size={size} onClick={onChange} disabled={disabled}>
        {checked ? (
          <CheckBox className={classes.checkedCheckbox} />
        ) : (
          <CheckBoxOutlineBlank className={classes.uncheckedCheckbox} />
        )}
      </IconButton>
      <div className={classes.label}>
        <Typography variant={labelVariant}>{label}</Typography>
      </div>
    </div>
  );
}

Checkbox.defaultProps = {
  size: SIZE.LARGE,
  color: COLOR.PRIMARY,
  label: '',
  labelVariant: 'body1',
  checked: false,
  disabled: false,
};

Checkbox.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZE)),
  color: PropTypes.oneOf(Object.values(COLOR)),
  label: PropTypes.string,
  labelVariant: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
